import { BaseApi } from '@/main/baseApi';
import { checkError } from '@/main/services/httpRequest';

import { NAME, DMS_MODULE } from './constants';

class SnimanieCasuProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	recordTime(casovaUdalost: { PracovnikId: number, CaswId: number | null, ZakazkaId: number | null }) 	{
		return this.post(`${this.apiPath}Insert`, casovaUdalost);
	}

	deleteLast(pracovnikId: number) {
		return checkError(this.axiosInstance.delete(`${this.apiPath}DeleteLast`, { params: { pracovnikId } }), true);
	}
}

export const apiProvider = new SnimanieCasuProvider();
